import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'QUEST_CLIENT',
  title: 'I miei clienti possono vedere con chi lavoro?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'La privacy è la partnership di fiducia che OnceForAll ha con i suoi clienti. Nessuno dei tuoi clienti può vedere con chi sei stato o con chi hai un contratto'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Questa privacy non esiste come parte di un\'operazione. Il cliente del tuo cliente può accedere alla tua cartella.'
  }]
};
